<template>
  <div>
    <nav-bar/>
    <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow">
      <ul class="nav flex-column">
        <li class="nav-item">
          <span class="nav-link navbar-text pull-left" @click="current = 'addressBook'" :class="{'current': current === 'addressBook'}">
            {{$t('AddressBook.sidebar.address_book')}}
          </span>
        </li>
        <li class="nav-item" v-if="$store.state.userInfo && $store.state.userInfo.isSageOne">
          <span class="nav-link navbar-text pull-left" @click="current = 'sageOne'" :class="{'current': current === 'sageOne'}">
            {{$t('AddressBook.sidebar.sageone')}}
          </span>
        </li>
        <li class="nav-item" v-if="$store.state.userInfo && $store.state.userInfo.isSageOne">
          <span class="nav-link navbar-text pull-left" @click="current = 'linkTrans'" :class="{'current': current === 'linkTrans'}">
            {{$t('AddressBook.sidebar.linkTrans')}}
          </span>
        </li>
        <li class="nav-item" v-if="$store.state.userInfo && $store.state.userInfo.isSageOne">
          <span class="nav-link navbar-text pull-left" @click="current = 'linkDeal'" :class="{'current': current === 'linkDeal'}">
            {{$t('AddressBook.sidebar.linkDeal')}}
          </span>
        </li>
        <button id="addCustomer" class="btn btn-kne-orange col-12 mt-3" @click="add = true; clear()">
          <i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i>
          {{$t('AddressBook.sidebar.add')}}
        </button>

        <json-excel class="btn btn-kne-orange col-12 mt-3"
        :data="JSON.parse(JSON.stringify(customers))"
        :fields="customers_fields"
        name="addressBook.xls">
          <!-- <i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i> -->
          {{$t('AddressBook.sidebar.excel')}}
        </json-excel>
      </ul>
    </div>
    <div class="font-grey view">
      <transition name="fade" mode="out-in">
        <div class="card" v-if="current === 'addressBook'" key="addressBook">
          <paginate name="filterResults" tag="div" :list="filterResults" class="" :per="30">
          <div class="table-responsive">
            <table class="table table-hover mb-0 table-sm">
              <thead class="bg-darkgrey">
                <tr>
                  <th @click="sortBy('name', false)" class="sortable nowrap">{{$t('AddressBook.name')}}<i v-if="sort.current === 'name'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('address', false)" class="sortable nowrap">{{$t('AddressBook.address')}}<i v-if="sort.current === 'address'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('phone', false)" class="sortable nowrap">{{$t('AddressBook.phone')}}<i v-if="sort.current === 'phone'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('fax', false)" class="sortable nowrap">{{$t('AddressBook.fax')}}<i v-if="sort.current === 'fax'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('email', false)" class="sortable nowrap">{{$t('AddressBook.email')}}<i v-if="sort.current === 'email'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('contact', false)" class="sortable nowrap">{{$t('AddressBook.contact')}}<i v-if="sort.current === 'contact'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th></th>
                </tr>
              </thead>
              <transition-group name="fade" tag="tbody">
                <tr key='filter'>
                  <td>
                    <regular-input
                      :value="fields.name"
                      @input="fields.name = $event; filteredSearchMethod()"
                      :placeholder="$t('AddressBook.name')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.address"
                      @input="fields.address = $event; filteredSearchMethod()"
                      :placeholder="$t('AddressBook.address')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.phone"
                      @input="fields.phone = $event; filteredSearchMethod()"
                      :placeholder="$t('AddressBook.phone')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.fax"
                      @input="fields.fax = $event; filteredSearchMethod()"
                      :placeholder="$t('AddressBook.fax')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.email"
                      @input="fields.email = $event; filteredSearchMethod()"
                      :placeholder="$t('AddressBook.email')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.contact"
                      @input="fields.contact = $event; filteredSearchMethod()"
                      :placeholder="$t('AddressBook.contact')"/>
                  </td>
                  <th></th>
                </tr>
                <tr v-for="customer in paginated('filterResults')" :key="customer['.key']">
                  <td class="nowrap"><p class="table-fix-width">{{customer.name}}</p></td>
                  <td class="nowrap">{{customer.address}}</td>
                  <td class="nowrap">{{customer.phone}}</td>
                  <td class="nowrap">{{customer.fax}}</td>
                  <td class="nowrap">{{customer.email}}</td>
                  <td class="nowrap">{{customer.contact}}</td>
                  <td>
                    <input @click.prevent="modifying(customer)" type="button" class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modify')">
                  </td>
                </tr>
              </transition-group>
            </table>
          </div>
          </paginate>
          <paginate-links for="filterResults" :hide-single-page="true" :limit="5"></paginate-links>
        </div>
        <div class="card" v-if="current === 'sageOne'" key="sageOne">
          <paginate name="filterResultsSageOne" tag="div" :list="filterResultsSageOne" class="" :per="30">
          <div class="table-responsive">
            <table class="table table-hover mb-0 table-sm">
              <thead class="bg-darkgrey">
                <tr>
                  <th>{{$t('AddressBook.name')}}</th>
                  <th>
                    <a class="btn btn-sm btn-kne-orange pull-right" target="_blank" :href="'https://mysageone.ca.sageone.com/oauth2/auth?response_type=code&client_id=3ff1477e6ec457b7df62&redirect_uri=https://systems.keepneye.com/sageone/SageoneToken&scope=full_access&transpuid='">
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                    </a>
                  </th>
                </tr>
              </thead>
              <transition-group name="fade" tag="tbody">
                <tr key='filter'>
                  <td>
                    <regular-input
                      :value="sageOneNameFilter"
                      @input="sageOneNameFilter = $event; filteredSearchMethodSage()"
                      :placeholder="$t('AddressBook.name')"/>
                  </td>
                  <th></th>
                </tr>
                <tr v-for="customer in paginated('filterResultsSageOne')" :key="customer['.key']" :class="{'linked': customer.C}">
                  <td class="nowrap">{{customer.A || customer.name}}</td>
                  <td>
                    <input @click.prevent="modifyingSage(customer)" type="button" class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modify')">
                  </td>
                </tr>
              </transition-group>
            </table>
          </div>
          </paginate>
          <paginate-links for="filterResultsSageOne" :hide-single-page="true" :limit="5"></paginate-links>
        </div>
        <div class="card" v-if="current === 'linkTrans'" key="linkTrans">
          <div class="table-responsive">
            <table class="table table-hover mb-0 table-sm">
              <thead class="bg-darkgrey">
                <tr>
                  <th>{{$t('AddressBook.name')}}</th>
                  <th></th>
                </tr>
              </thead>
              <transition-group name="fade" tag="tbody">
                <tr v-for="t in trans" :key="t['.key']" :class="{'linked': t.linked}">
                  <td class="nowrap">{{t.name}}</td>
                  <td>
                    <input @click.prevent="modifyingTransDealSage(t, 'transporter')" type="button" class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modify')">
                  </td>
                </tr>
              </transition-group>
            </table>
          </div>
        </div>
        <div class="card" v-if="current === 'linkDeal'" key="linkDeal">
          <div class="table-responsive">
            <table class="table table-hover mb-0 table-sm">
              <thead class="bg-darkgrey">
                <tr>
                  <th>{{$t('AddressBook.name')}}</th>
                  <th></th>
                </tr>
              </thead>
              <transition-group name="fade" tag="tbody">
                <tr v-for="d in deal" :key="d['.key']" :class="{'linked': d.linked}">
                  <td class="nowrap">{{d.name}}</td>
                  <td>
                    <input @click.prevent="modifyingTransDealSage(d, 'dealer')" type="button" class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modify')">
                  </td>
                </tr>
              </transition-group>
            </table>
          </div>
        </div>
      </transition>
    </div>
    <transition name="fade">
      <modal v-if="modifySage" @close-request="modifySage = false" closable>
        <h4 class="kne-title mx-3">{{$t('AddressBook.sageone_change_title')}}</h4>
        <div class="col-12">{{sageOneChange.target.A || sageOneChange.target.name}}</div>
        <regular-datalist
          multiSelect
          :value="datalist.name"
          @input="setSage($event)"
          :secondList="customers"
          :thirdList="dealerTrans"
          class="col-12 form-group datalist"/>
        <transition-group tag="div" name="fade" id="multi" class="container-fluid">
          <span v-if="customer.key" v-for="(customer, index) in sageCustomer" class="badge badge-kne mr-2" :key="customer.key">
            {{customer.value}}
            <i @click="sageCustomer.splice(index, 1)" class="fa fa-times fa-lg p-1 delete" aria-hidden="true"></i>
          </span>
        </transition-group>
          <div class="col-12 mt-3">
            <input :disabled="sageCustomer.length < 1" @click="SubmitmodifySage()" type="button" class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modifySageSubmit')">
          </div>
      </modal>
      <modal v-if="modifySageDealTrans" @close-request="modifySageDealTrans = false" closable>
        <h4 class="kne-title mx-3">{{$t('AddressBook.sageone_change_title')}}</h4>
        <div class="col-12">{{sageOneChange.target.name}}</div>
        <regular-datalist
          :value="datalist.name"
          @input="datalist.name = $event.value; datalist.key = $event.key"
          :sageOne="sageone"
          class="col-12 form-group datalist"/>
          <div class="col-12 mt-3">
            <input :disabled="datalist.key === null" @click="SubmitmodifyTransDealSage()" type="button" class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modifySageSubmit')">
          </div>
      </modal>
      <modal v-if="add === true || modify === true" @close-request="add = false; modify = false" closable>
        <h4 v-if="add" class="kne-title mx-3">{{$t('AddressBook.addTitle')}}</h4>
        <h4 v-else class="kne-title mx-3">{{$t('AddressBook.modifyTitle')}}</h4>
        <div class="">
          <regular-input
          :value="customer.name"
          @input="customer.name = $event"
          type="text" :placeholder="$t('AddressBook.name') + '*'" class="col-12 form-group"/>
          <regular-input
          :value="customer.address"
          @input="customer.address = $event"
          type="text" :placeholder="$t('AddressBook.address') + '*'" class="col-12 form-group"/>
          <regular-input
          :value="customer.postcode"
          @input="customer.postcode = $event"
          type="text" :placeholder="$t('AddressBook.postCode') + '*'" class="col-12 form-group"/>
          <regular-input
          :value="customer.phone"
          @input="customer.phone = $event"
          type="text" :placeholder="$t('AddressBook.phone') + '*'" class="col-12 form-group"/>
          <regular-input
          :value="customer.city"
          @input="customer.city = $event"
          type="text" :placeholder="$t('AddressBook.city')" class="col-12 form-group"/>
          <regular-input
          :value="customer.province"
          @change="customer.province = $event"
          :placeholder="$t('AddressBook.province')" class="col-12 form-group"/>
          <regular-select
          :value="customer.country"
          @change="customer.country = $event"
          :placeholder="$t('AddressBook.country')" class="col-12 form-group">
            <option>Canada</option>
            <option>US</option>
          </regular-select>
          <regular-input
          :value="customer.email"
          @input="customer.email = $event"
          type="text" :placeholder="$t('AddressBook.email')" class="col-12 form-group"/>
          <regular-input
          :value="customer.receptionEmail"
          @input="customer.receptionEmail = $event"
          type="text" :placeholder="$t('AddressBook.receptionEmail')" class="col-12 form-group"/>
          <regular-input
          :value="customer.fax"
          @input="customer.fax = $event"
          type="text" :placeholder="$t('AddressBook.fax')" class="col-12 form-group"/>
          <regular-input
          :value="customer.contact"
          @input="customer.contact = $event"
          type="text" :placeholder="$t('AddressBook.contact')" class="col-12 form-group"/>
          <regular-input
          :value="customer.sageID"
          @input="customer.sageID = $event"
          type="text" :disabled="true" :placeholder="$t('AddressBook.sageID')" class="col-12 form-group"/>
          <regular-input
          :value="customer.comments"
          @input="customer.comments = $event"
          type="text" :placeholder="$t('AddressBook.comments')" class="col-12 form-group"/>
        </div>
        <div class="col-12">
          <button v-if="add" class="btn btn-kne-orange w-100" :disabled="!customerFilledForm" @click="addCustomer()">{{$t('AddressBook.addSubmit')}}</button>
          <button v-else class="btn btn-kne-orange w-100" :disabled="!customerFilledForm" @click="modifyCustomer()">{{$t('AddressBook.modifySubmit')}}</button>
        </div>
        <h4 v-if="modify && isAdmin" class="kne-title mx-3 mt-3">{{$t('AddressBook.deleteTitle')}}</h4>
        <div class="col-12">
          <button v-if="modify && isAdmin" class="btn btn-danger w-100" @click="deleteCustomer()">{{$t('AddressBook.deleteUser')}}</button>
        </div>
      </modal>
    </transition>
  </div>
</template>

<script>
import Modal from '../Modal.vue'
import regularInput from '../regularInput.vue'
import regularCheckbox from '../regularCheckbox.vue'
import regularTextarea from '../regularTextarea.vue'
import regularSelect from '../regularSelect.vue'
import Search from '../module/Search.vue'
import {db} from '../../firebase'
import _ from 'lodash'
import JsonExcel from 'vue-json-excel'

export default {
  name: 'AddressBook',
  components: {
    Modal,
    regularInput,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    Search,
    JsonExcel
  },
  data () {
    return {
      customers_fields: {
        'name': 'name',
        'address': 'address',
        'city': 'city',
        'email': 'email',
        'phone': 'phone',
        'postcode': 'postcode',
        'province': 'province',
        'country': 'country',
        'comments': 'comments',
        'contact': 'contact'
      },
      current: 'addressBook',
      sageOneNameFilter: '',
      sageOneChange: {
        target: {},
        type: ''
      },
      modifySage: false,
      modifySageDealTrans: false,
      datalist: {
        name: '',
        key: null
      },
      sageCustomer: [],
      add: false,
      modify: false,
      key: '',
      customer: {
        name: '',
        address: '',
        phone: '',
        fax: '',
        email: '',
        receptionEmail: '',
        contact: '',
        postcode: '',
        city: '',
        province: '',
        country: '',
        comments: '',
        sageID: ''
      },
      provinces: ['BC', 'ON', 'NL', 'NS', 'PE', 'NB', 'QC', 'MB', 'SK', 'AB', 'NT', 'NU', 'YT'],
      fields: {
        name: '',
        address: '',
        phone: '',
        fax: '',
        email: '',
        contact: ''
      },
      filterResults: [],
      filterResultsSageOne: [],
      customers: [],
      dealerTrans: [],
      sageone: [],
      paginate: ['filterResults', 'filterResultsSageOne'],
      sort: {
        current: '',
        desc: true
      },
      trans: [],
      deal: []
    }
  },
  computed: {
    customerFilledForm: function () {
      if (
        this.customer.name !== '' &&
        this.customer.phone !== '' &&
        this.customer.address !== '' &&
        this.customer.postcode !== '') return true
      else return false
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    },
    uid () {
      return this.$store.state.user.uid
    }
  },
  methods: {
    setSage (event) {
      // console.log(event)
      console.log(event)
      if (event.key) {
        this.datalist.name = event.originalVal
        delete event.originalVal
        this.sageCustomer.push(event)
      } else this.datalist.name = event.value
      // this.datalist.key = event.key
      // this.datalist.dealer = event.dealer
      // this.datalist.transporter = event.transporter
    },
    SubmitmodifySage () {
      // console.log('submit')
      this.sageCustomer.forEach((customer) => {
        if (customer.dealer && customer.key) {
          db.ref('users/dealers/' + customer.key + '/sageID').set(this.sageOneChange.target.B)
          // ======================== ADD MODIFICATION DEALER SAGE LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_DEALER_MODIFICATION', 'targetUID': customer.key, 'date': Date.now(), 'targetName': this.sageOneChange.target.A})
          // ======================== ADD MODIFICATION DEALER SAGE LOG =======================
        }
        if (customer.transporter && customer.key) {
          db.ref('users/transporters/' + customer.key + '/sageID').set(this.sageOneChange.target.B)
          // ======================== ADD MODIFICATION TRANSPORTER SAGE LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_TRANSPORTER_MODIFICATION', 'targetUID': customer.key, 'date': Date.now(), 'targetName': this.sageOneChange.target.A})
          // ======================== ADD MODIFICATION TRANSPORTER SAGE LOG =======================
        }
        if (!customer.dealer && !customer.transporter && customer.key) {
          db.ref('database/transporter/' + this.companyUID + '/carnet/' + customer.key + '/sageID').set(this.sageOneChange.target.B)
          // ======================== ADD MODIFICATION SAGE LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_MODIFICATION', 'targetUID': customer.key, 'date': Date.now(), 'targetName': this.sageOneChange.target.A})
          // ======================== ADD MODIFICATION SAGE LOG =======================
        }
      })
      db.ref('sageoneid/' + this.companyUID).child(this.sageOneChange.target['.key']).child('C').set(this.sageCustomer).then(() => {
        this.modifySage = false
      })
    },
    SubmitmodifyTransDealSage () {
      var uid = this.companyUID
      if (this.sageOneChange.type === 'transporter') {
        db.ref('users/transporters').child(this.sageOneChange.target['.key']).update({sageID: this.datalist.key}).then(() => {
          this.modifySageDealTrans = false
        })
        db.ref('users/transporters').child(uid).child('listTrans').child(this.sageOneChange.target['.key']).update({linked: true})
        // ======================== ADD SAGE TRANSPORTER LINK LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_TRANSPORTER_LINK', 'targetUID': this.sageOneChange.target['.key'], 'date': Date.now(), 'targetName': this.sageOneChange.target.name})
        // ======================== ADD SAGE TRANSPORTER LINK LOG =======================
      } else {
        db.ref('users/dealers').child(this.sageOneChange.target['.key']).update({sageID: this.datalist.key}).then(() => {
          this.modifySageDealTrans = false
        })
        db.ref('users/transporters').child(uid).child('listDeal').child(this.sageOneChange.target['.key']).update({linked: true})
        // ======================== ADD SAGE LINK LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_LINK', 'targetUID': this.sageOneChange.target['.key'], 'date': Date.now(), 'targetName': this.sageOneChange.target.name})
        // ======================== ADD SAGE LINK LOG =======================
      }
    },
    filteredSearchMethod: _.debounce(function () {
      this.filterResults = []
      this.filterResults = this.customers.filter((entry) => {
        var result = true
        for (var attr in this.fields) {
          if (this.fields[attr] !== '') {
            var reg = this.fields[attr].replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
            var re = new RegExp(reg, 'i')
            result = re.test(entry[attr])
          }
          if (result === false) break
        }
        return result
      })
      this.filterResults.reverse()
      this.sortBy(this.sort.current, true)
    }, 100),
    filteredSearchMethodSage: _.debounce(function () {
      this.filterResultsSageOne = []
      this.filterResultsSageOne = this.sageone.filter((entry) => {
        // var result = true
        var reg = this.sageOneNameFilter.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        var re = new RegExp(reg, 'i')
        var result = re.test(entry.A)
        // if (result === false) break
        return result
      })
      // this.filterResultsSageOne = this.filterResultsSageOne.concat(this.dealerTrans)
    }, 100),
    addCustomer: function () {
      db.ref('database/transporter/' + this.companyUID + '/carnet').push().set(this.customer).then(() => {
        // ======================== ADD CUSTOMER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ADD_CUSTOMER', 'customerName': this.customer.name, 'date': Date.now()})
        // ======================== ADD CUSTOMER LOG =======================
        this.add = !this.add
        this.clear()
      })
    },
    modifyCustomer: function () {
      db.ref('database/transporter/' + this.companyUID + '/carnet/' + this.key).update(this.customer).then(() => {
        // ======================== ADD CUSTOMER MODIFICATION LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'MODIFY_CUSTOMER', 'customerName': this.customer.name, 'date': Date.now()})
        // ======================== ADD CUSTOMER MODIFICATION LOG =======================
        this.modify = !this.modify
        this.clear()
      })
    },
    modifying: function (customer) {
      this.modify = true
      for (var attr in this.customer) {
        this.customer[attr] = customer[attr]
        if (customer[attr] === undefined) this.customer[attr] = ''
      }
      this.key = customer['.key']
    },
    modifyingSage: function (customer) {
      this.sageOneChange.target = customer
      this.datalist.name = ''
      this.datalist.key = null
      this.sageCustomer = Object.values(customer.C || {})
      this.modifySage = true
    },
    modifyingTransDealSage (dealerTrans, type) {
      this.sageOneChange.target = dealerTrans
      this.sageOneChange.type = type
      this.datalist.name = ''
      this.datalist.key = null
      this.modifySageDealTrans = true
    },
    clear: function () {
      for (var attr in this.customer) {
        this.customer[attr] = ''
      }
    },
    deleteCustomer: function () {
      db.ref('database/transporter/' + this.companyUID + '/carnet/').child(this.key).remove().then(() => {
        // ======================== ADD CUSTOMER MODIFICATION LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'DELETE_CUSTOMER', 'customerName': this.customer.name, 'date': Date.now()})
        // ======================== ADD CUSTOMER MODIFICATION LOG =======================
        this.modify = !this.modify
        this.clear()
      })
    },
    sortBy (criteria, newEntry) {
      if (this.sort.current === criteria && !newEntry) {
        this.sort.desc = !this.sort.desc
      } else if (!newEntry) {
        this.sort.desc = true
        this.sort.current = criteria
      }
      this.filterResults.sort((a, b) => {
        if (a[criteria] === undefined) a[criteria] = ''
        if (b[criteria] === undefined) b[criteria] = ''
        var A = a[criteria]
        var B = b[criteria]
        if (criteria !== 'creationDate') {
          A = a[criteria].toUpperCase() // ignore upper and lowercase
          B = b[criteria].toUpperCase() // ignore upper and lowercase
        }
        if (!this.sort.desc) {
          if (A < B) {
            return -1
          }
          if (A > B) {
            return 1
          }
        } else {
          if (A > B) {
            return -1
          }
          if (A < B) {
            return 1
          }
        }
        // names must be equal
        return 0
      })
    }
  },
  created () {
    var id = this.companyUID
    this.$bindAsArray('customers', db.ref('database/transporter/' + id + '/carnet'), null, () => {
      this.filteredSearchMethod()
    })
    this.$bindAsArray('sageone', db.ref('sageoneid/' + id), null, () => {
      this.filteredSearchMethodSage()
    })
    this.$bindAsArray('dealerTrans', db.ref('database/transporter/' + id + '/customer'), null, () => {
      this.filteredSearchMethodSage()
    })
    this.$bindAsArray('trans', db.ref('users/transporters/' + id + '/listTrans'))
    this.$bindAsArray('deal', db.ref('users/transporters/' + id + '/listDeal'))
  },
  watch: {
    customers: function () {
    // console.log('Processing watcher fired')
      this.filteredSearchMethod()
    },
    sageone: function () {
      this.filteredSearchMethodSage()
    },
    dealers: function () {
      this.filteredSearchMethodSage()
    },
    transporters: function () {
      this.filteredSearchMethodSage()
    },
    dealerTrans: function () {
      this.filteredSearchMethodSage()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.delete {
  border-radius: 4px;
  cursor: pointer;
}
.delete:hover {
  background-color: #666e71;
  transition: all linear 150ms;
}
.badge-kne {
  background-color: #2c2d2f;
}
p.table-fix-width {
  /*max-width: 15rem;*/
}
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
input, button{
  cursor: pointer;
}
.current {
  border-left: 3px solid #f7941e;
}
.datalist {
  margin-bottom: 0px;
}
.linked {
  background-color: #B4EEB4;
}
</style>



// WEBPACK FOOTER //
// AddressBook.vue?abd2b652